export default {
  appsTitle: { id: 'apps' },
  appsDescription: { id: 'apps_description' },
  slaMonitor: { id: 'sla_monitor' },
  seaLice: { id: 'sea_lice' },
  pew: { id: 'environment_monitor' },
  pewDesc: { id: 'pew_desc' },
  salesPrediction: { id: 'sales_prediction' },
  healthMonitor: { id: 'health_monitor' },
  logbook: { id: 'logbook' },
  cageCompare: { id: 'cage_compare' },
  comingSoon: { id: 'coming_soon' },
  slaMonitorDesc: { id: 'sla_monitor_description' },
  seaLiceDesc: { id: 'sea_lice_description' },
  empty: { id: 'empty' },
  actual: { id: 'actual' },
  salesDashboard: { id: 'dashboards' },
  salesDashboardDesc: { id: 'dashboardsDesc' },
  logbookDesc: { id: 'logbook_description' },
  sensorsMonitor: { id: 'sensors_monitor' },
  sensorsDesc: { id: 'sensors_description' },
  seawaterProduction: { id: 'seawater_production' },
  ectoMaps: { id: 'ecto_maps' },
  ectoMapsDesc: { id: 'ecto_maps_desc' },
  ectoDashboards: { id: 'ecto_dashboards' },
  ectoDashboardsDesc: { id: 'ecto_dashboards_desc' },
  ectoSatellites: { id: 'ecto_satellites' },
  ectoSatellitesDesc: { id: 'ecto_satellites_desc' },
  dailyLogbookEvents: { id: 'daily_logbook_events' },
  dailyLogbookStatus: { id: 'daily_logbook_status' },
  dailyLogbookStatusDesc: { id: 'daily_logbook_status_desc' },
  dailyLogbookDesc: { id: 'daily_logbook_description' },
  dataBrowser: { id: 'data_browser' },
  dataBrowserDesc: { id: 'data_browser_desc' },
  logbookForms: { id: 'logbook_forms' },
  logbookFormsDesc: { id: 'logbook_forms_desc' },
  seawaterMortality: { id: 'seawater_mortality' },
  seawaterMortalityDesc: { id: 'seawater_mortality_description' },
  ovaMortality: { id: 'ova_mortality' },
  ovaMortalityDesc: { id: 'ova_mortality_description' },
  biomassSensors: { id: 'biomass_sensors' },
  biomassSensorsDesc: { id: 'biomass_sensors_description' },
  transferPerformance: { id: 'transfer_performance' },
  transferPerformanceDesc: { id: 'transfer_performance_description' },
  mySeawaterSites: { id: 'my_seawater_sites' },
  mySeawaterSitesDesc: { id: 'my_seawater_sites_desc' },
  weather: { id: 'weather' },
  weatherDesc: { id: 'weather_desc' },
  mortalityForecast: { id: 'mortality_forecast' },
  mortalityForecastDesc: { id: 'mortality_forecast_desc' },
  appsStore: { id: 'apps_store' },
  monitorsAndAlerts: { id: 'monitors_and_alerts' },
  monitorsAndAlertsDesc: { id: 'monitors_and_alerts_description' },
  myLogs: { id: 'my_logs' },
  myLogsDesc: { id: 'my_logs_description' },
  samplingDistributionAndFrequency: {
    id: 'sampling_distribution_and_frequency',
  },
  stocking: { id: 'stocking' },
  lotTraceability: { id: 'lot_traceability' },
  freshwaterProduction: { id: 'freshwater_production' },
  freshwaterProductionDesc: { id: 'freshwater_production_desc' },
}
